module.exports = __webpack_public_path__ + "img/ss.3a7c2037.svg";